import { useState } from "react";

const usePagination = ({ quantity }) => {
    const [pagination, setPagination] = useState({ skip: 0, top: quantity });

    const pcaginationHandler = source => {
        const _pagination = { skip: source, top: pagination.top };
        
        setPagination(_pagination);
    };

    return [pagination, pcaginationHandler];
};

export default usePagination;
